export enum ScenarioMode {
    portfolio = 'portfolio',
    fund = 'fund',
}
